import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import router from 'umi/router';
import { stringify } from 'qs';
import { Tooltip, Row, Col, Button, Form, DatePicker, Input } from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import { getPathHeader } from '../../../../../utils/utils';
import styles from './index.less';

const { ListTable } = ListPage;
const { RangePicker } = DatePicker;
// const statusIcon = {
//   1: "#0CADE3",
//   2: "#E64340",
//   3: "#BFBFBF",
//   4: "#bfbfbf"
// };

// const statusText = {
//   1: "已上报",
//   2: "未上报",
//   3: "教育局打回",
//   4: "已撤回"
// };

@connect()
class Reportedrecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        title: '',
        start_time: '',
        end_time: '',
      },
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchUpRecord(params);
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          start_time: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYYMMDD') : '',
          end_time: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYYMMDD') : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchUpRecord(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = {
      ...params,
      title: '',
      start_time: '',
      end_timg: '',
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchUpRecord(tempParams);
  };

  fetchUpRecord = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'report/fetchUpRecord',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  toRecord = record => {
    const returnUrl = `${window.location.pathname}`;
    const params = `?${stringify({
      id: record.applyId,
      returnUrl,
    })}`;
    router.push(`/${getPathHeader()}/publish/record/workflow${params}`);
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        render: text => {
          if (text.length <= 12) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'NewsInfoExtend',
        key: 'NewsInfoExtend',
        render: NewsInfoExtend => {
          return <span>上报教育局</span>;
        },
      },
      {
        title: '操作人',
        dataIndex: 'upUserName',
        key: 'upUserName',
      },
      {
        title: '上报时间',
        dataIndex: 'upTime',
        key: 'upTime',
        width: 160,
        render: text => {
          return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
      // {
      //   title: "状态",
      //   dataIndex: "upStatus",
      //   key: "upStatus",
      //   render: text => {
      //     return <Badge color={statusIcon[text]} text={statusText[text]} />;
      //   }
      // }
      // {
      //   title: '操作',
      //   dataIndex: 'action',
      //   key: 'action',
      //   render: (text, record) => {
      //     if (record.applyId && record.applyId !== 0) {
      //       return <a onClick={() => this.toRecord(record)}>查看流转记录</a>;
      //     }
      //     return <span>-</span>;
      //   },
      // },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchUpRecord(tempParams);
  };

  // 跳转详情
  handleGoToDetail = (id, record) => {
    router.push(
      `/${getPathHeader()}/operateRecord/record/approvalDetail?id=${
        record.newsId
      }&appCode=${getAppCode()}`
    );
  };

  render() {
    const { columns, loading, dataSource, params, totalElements } = this.state;
    const { page } = params;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={10}>
              <Form.Item {...formItemLayout} label="文章标题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="同步时间" {...formItemLayout}>
                {getFieldDecorator(
                  `range-picker`,
                  {}
                )(<RangePicker format="YYYY-MM-DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            <Col offset={20} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>
      </Container>
    );
  }
}
const ReportedRecord = Form.create()(Reportedrecord);
export default ReportedRecord;
